import React, { useEffect } from "react";
import LoginForm from "components/Login/LoginForm";

const Login = () => {
  useEffect(() => {
    document.title =
      "Administration Panel | Mind Pulse | Login to your Mind Pulse Account";
  }, []);

  return (
    <>
      <div className="flex flex-row">
        <div className="relative w-1/2">
          <img
            className="w-full h-screen object-cover"
            src={require("../../assets/images/login_sidebar.webp")}
          />

          <div className="absolute bottom-10 left-8 right-8 z-10">
            <h2 style={{ color: "#ffffff", fontSize: 28, fontWeight: "600" }}>
              Be Proactive with Health and Wellbeing
            </h2>
            <p style={{ color: "#ffffff", fontSize: 18, fontWeight: "500" }}>
              Login to control the Mind Pulse Platform
            </p>
          </div>
        </div>

        <div className="w-1/2">
          <div className="flex h-screen flex-col justify-center items-center">
            <img
              className="w-1/4 object-contain"
              src={require("../../assets/images/appicon.png")}
            />
            <div className="w-2/3">
              <h5 className="font-medium text-black text-xl">
                Administration Panel
              </h5>

              <p className="font-light text-black text-lg mb-4">
                Login to control, and update information on the Mind Pulse
                Platform.
              </p>
              <LoginForm hasLabel={true} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
